/** Geotab's placeholders for "nobody logged in" / no driver. */
export const NO_DRIVER_IDS: ReadonlySet<string> = new Set(["NoDriverId", "UnknownDriverId"]);

/** False for empty, missing and placeholder ids. */
export function isRealDriverId(id: string | null | undefined): id is string {
  return !!id && !NO_DRIVER_IDS.has(id);
}
